module.exports = __webpack_public_path__ + "static/img/6.f1ab483.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-en/6.jpg
// module id = Sihr
// module chunks = 1